import React, { useEffect, useState } from "react";
import strings from "../../resources/strings.json";
import { Button, Dropdown, FormControl } from "react-bootstrap";
import "./VoluntaryTOffComponent.scss";

const DropdownSelect = props => {

    const {
        options,
        title,
        selectedOption,
        setSelectedOption,
        isRequired,
        isRequiredRedAsterick,
        isEnabled,
        width,
        error,
        inputEnabled,
        allowTyping,
        labelClassName,
        optionsTrigger // NEW: trigger to recalc options
    } = props;

    const isTypingAllowed = allowTyping !== false;

    const [searchQuery, setSearchQuery] = useState(selectedOption);
    const [filteredItems, setFilteredItems] = useState(options);
    const [isOpen, setIsOpen] = useState(false);
    const [isError, setIsError] = useState(false);

    const handleSelectItem = (item) => {
            setSelectedOption(item);
            setSearchQuery(item);
            setIsError(false);
    };

   const handleSearchChange = (e) => {
    let query = e.target.value;
    setIsOpen(true);

    if (title === "Hour" || title === "Minutes") {
        query = query.replace(/[^0-9]/g, "");
    } else {
        query = query.replace(/[^a-zA-Z0-9\s]/g, "");
    }

    setSearchQuery(query);

    if (query.length === 0) {
        setFilteredItems(options);
        setSelectedOption("");
    } else {
        if (options.includes(query)) {
            setSelectedOption(query);
        } else if (inputEnabled) {
            setSelectedOption(query.toUpperCase());
        }
        const filtered = options.filter(item =>
            item.toLowerCase().includes(query.toLowerCase())
        );

        if (filtered.length === 0 && !inputEnabled) {
            setIsError(true);
            setIsOpen(true);
            setFilteredItems([]);
        } else {
            setIsError(false);
            setIsOpen(true);
            setFilteredItems(filtered);
        }
    }
};
    
    useEffect(() => {
        if (title === 'Station' || title === 'Department' || title === 'Classification' || title === 'Duty Assignment') {
            setFilteredItems(options);
            if (!selectedOption) setSearchQuery("");
        }
        if (!searchQuery) setFilteredItems(options);
    }, [options]);

    useEffect(() => {
        setFilteredItems(options);
        setSearchQuery(selectedOption);
    }, [optionsTrigger]);
    
    useEffect(() => {
        setSearchQuery(selectedOption);
    }, [selectedOption]);

    useEffect(() => {
        if (options && options.length < filteredItems.length )setFilteredItems(options);
    }, [options]);
    
    return (
        <div>
            <label className={`dropdown-label ${labelClassName || ""} ${!isEnabled && "disabled"}`}>
                {title} {isRequired && " - Required"} {isRequiredRedAsterick && <span style={{ color: 'red'}}>*</span>}
            </label>

            <Dropdown className={`dropdown-container ${!isEnabled && "disabled"}`}>
                <Dropdown.Toggle
                    as={FormControl}
                    value={searchQuery}
                    onChange={isEnabled && isTypingAllowed ? handleSearchChange : undefined}
                    className={`custom-dropdown-toggle ${!isEnabled && "disabled"} ${width}`} 
                    attr={`${(error || isError )&& "error"}`}
                    style={{ height: '38px' }}
                    disabled={!isEnabled || options == undefined || options?.length === 0}
                    readOnly={!isTypingAllowed}
                    placeholder=""
                />
                {isEnabled&&<Dropdown.Menu style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {filteredItems&&filteredItems.map((item, index) => (
                        <Dropdown.Item 
                            eventKey={item} 
                            key={`${item}-${index}`} 
                            id={item} 
                            className="dropdown-item"
                            onClick={() => handleSelectItem(item)}
                        >
                            {item}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>}
            </Dropdown>
        </div>
    );
};

export default DropdownSelect;
